import React from 'react';
import { ApiClient } from '~client/client/api-client';
import { apiClient } from '~web/client/index';

interface Props {
  client: ApiClient;
}

const clientContext = React.createContext<Props | null>(null);

export const ClientProvider: React.FunctionComponent<Props> = ({ client, children }) => {
  return <clientContext.Provider value={{ client }}>{children}</clientContext.Provider>;
};

export const YoopApiClientProvider: React.FunctionComponent = ({ children }) => {
  return <ClientProvider client={apiClient}>{children}</ClientProvider>;
};

export const useApiClient = (): ApiClient => {
  const context = React.useContext(clientContext);
  if (!context) {
    throw new Error('useApiClient must be used within ApiClientProvider.');
  }
  return context.client;
};



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/web/src/js/client/api-client-provider.tsx